module.exports = {
  openModal: { type: Boolean },
  contentId: { type: String },
  tab: { type: String },
  broadcastId: { type: String },
};
